import React from 'react';

/** Local MMM machine icons — original SVGs in-repo (no remote downloads). */
function MachineSvg({ size = 14, color = 'currentColor', children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {children({ color })}
    </svg>
  );
}

export function GeneratorIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <rect x="6" y="9" width="12" height="10" rx="1.5" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <path d="M9 9V7h6v2" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <path d="M10 13h4M10 16h4" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <circle cx="17.5" cy="14" r="1.2" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function ExcavatorIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <rect x="3" y="14" width="11" height="5" rx="1" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <path d="M12 14l5-6 3 1-4 7" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}18`} />
          <path d="M17 8l2-4h2" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <circle cx="6" cy="19.5" r="1.4" fill={c} />
          <circle cx="11" cy="19.5" r="1.4" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function DumpTruckIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <path d="M3 15h11l1-5H9L8 15" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}22`} />
          <path d="M14 15h4l2-3h-4l-2 3z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}33`} />
          <rect x="3" y="15" width="4" height="3" rx="0.5" stroke={c} strokeWidth="1.4" />
          <circle cx="7" cy="19" r="1.5" fill={c} />
          <circle cx="16" cy="19" r="1.5" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function TipperTruckIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <path d="M4 16h10v-5H9l-1 5" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}22`} />
          <path d="M14 11l5-2 1 3-4 4H14V11z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}33`} />
          <circle cx="7" cy="19" r="1.5" fill={c} />
          <circle cx="15" cy="19" r="1.5" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function RollerIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <rect x="8" y="10" width="9" height="6" rx="1" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <circle cx="6" cy="16" r="3.2" stroke={c} strokeWidth="1.6" fill={`${c}33`} />
          <circle cx="18.5" cy="16.5" r="2.2" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <path d="M9 10V8h5v2" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </MachineSvg>
  );
}

export function CraneIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <path d="M5 20h8" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <path d="M8 20V8l10-4v3" stroke={c} strokeWidth="1.6" strokeLinejoin="round" />
          <path d="M18 7v8" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <path d="M16 15h4" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <rect x="6.5" y="16" width="5" height="4" rx="0.5" stroke={c} strokeWidth="1.4" fill={`${c}22`} />
        </>
      )}
    </MachineSvg>
  );
}

export function TractorIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <path d="M10 14h7l1-4h-5l-1 4z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}22`} />
          <circle cx="7" cy="17" r="3" stroke={c} strokeWidth="1.6" fill={`${c}33`} />
          <circle cx="17" cy="17.5" r="2" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <path d="M10 14V11h3" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </MachineSvg>
  );
}

export function WaterTankIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <ellipse cx="12" cy="11" rx="7" ry="4" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <path d="M5 11v4c0 2.2 3.1 4 7 4s7-1.8 7-4v-4" stroke={c} strokeWidth="1.6" />
          <path d="M9 9.5c.8-.5 1.8-.8 3-.8" stroke={c} strokeWidth="1.3" strokeLinecap="round" />
          <circle cx="8" cy="19" r="1.3" fill={c} />
          <circle cx="16" cy="19" r="1.3" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function BreakerIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <path d="M8 4h4l2 6H9L8 4z" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}22`} />
          <path d="M10 10v8M8 18h4" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
          <path d="M7 14h6" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="14.5" cy="7" r="1.2" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function JcbIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <rect x="6" y="11" width="9" height="6" rx="1" stroke={c} strokeWidth="1.6" fill={`${c}22`} />
          <path d="M15 12l4-5 2 1-3 6" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}18`} />
          <path d="M9 11V9h4v2" stroke={c} strokeWidth="1.5" />
          <circle cx="8.5" cy="18.5" r="1.5" fill={c} />
          <circle cx="13.5" cy="18.5" r="1.5" fill={c} />
        </>
      )}
    </MachineSvg>
  );
}

export function GenericMachineIcon({ size, color }) {
  return (
    <MachineSvg size={size} color={color}>
      {({ color: c }) => (
        <>
          <path d="M4 16h12l2-5H10L8 16" stroke={c} strokeWidth="1.6" strokeLinejoin="round" fill={`${c}22`} />
          <rect x="4" y="16" width="3.5" height="2.5" rx="0.4" stroke={c} strokeWidth="1.3" />
          <circle cx="8" cy="19.5" r="1.4" fill={c} />
          <circle cx="15" cy="19.5" r="1.4" fill={c} />
          <path d="M12 11V8" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </MachineSvg>
  );
}

/** Pick a local machine silhouette from the item name. */
export function machineIconFor(name) {
  const n = String(name || '').toLowerCase();
  if (n.includes('generat') || n.includes('power')) return GeneratorIcon;
  if (n.includes('excav') || n.includes('backhoe')) return ExcavatorIcon;
  if (n.includes('jcb') || n.includes('loader')) return JcbIcon;
  if (n.includes('tipper')) return TipperTruckIcon;
  if (n.includes('dump') || n.includes('truck') || n.includes('trolley') || n.includes('trailer')) {
    return DumpTruckIcon;
  }
  if (n.includes('roller')) return RollerIcon;
  if (n.includes('crain') || n.includes('crane')) return CraneIcon;
  if (n.includes('water') || n.includes('tank')) return WaterTankIcon;
  if (n.includes('breaker') || n.includes('hydraulic')) return BreakerIcon;
  if (n.includes('tractor')) return TractorIcon;
  return GenericMachineIcon;
}
